import auth from "./entities/auth.js";
import crew from "./entities/crew.js";
import economosList from "./entities/economosList.js";
import economosMovement from "./entities/economosMovement.js";
import enemy from "./entities/enemy.js";
import houseItem from "./entities/houseItem.js";
import houseItemCategory from "./entities/houseItemCategory.js";
import houseItemList from "./entities/houseItemList.js";
import houseTask from "./entities/houseTask.js";
import settings from "./entities/settings.js";
import splitExpense from "./entities/splitExpense.js";
import splitExpenseGroup from "./entities/splitExpenseGroup.js";

export const endpoints = {
	auth,
	crew,
	settings,
	houseTask,
	enemy,
	houseItem,
	houseItemCategory,
	houseItemList,
	economosList,
	economosMovement,
	splitExpenseGroup,
	splitExpense,
};
